import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-mt-10 -mb-4 min-h-44 max-h-44" }

import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'

	
// name the component
	const __default__ = { name: 'JobDiscounts' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noDiscounts'),
      data: props?.job?.portalData?.portal_discounts,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('154')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.percentage(row['job__DISCOUNTS__jobID::percentage_discount'])), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('155'),
          prop: "job__DISCOUNTS__jobID::reason_display"
        }, null, 8, ["header"])
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ]))
}
}

})